<template>
  <v-hover v-slot="{ hover }">
    <v-card v-if="event || org" :flat="!hover" :color="hover ? 'grey lighten-4' : 'white'" :to="eventMode ? {name: 'eventmanagerInsights', params: {id: event.id}} : {name: 'orgmanagerInsights', params: {id: org.id}}">
      <v-row>
        <v-col cols="12">
          <v-card-title>Insights <v-icon small color="black" class="ms-2 ">fa fa-chevron-right</v-icon></v-card-title>
          <v-card-subtitle>Key Metrics <span v-if="snapshot" class="not-bold">period {{snapshot.from | localDate('D', true) }} - {{snapshot.till | localDate('D', true) }}</span></v-card-subtitle>
          <v-container v-if="snapshot" class="container--min-height px-4">
            <v-row class="row--separated">
              <v-col cols="4">
                <v-card flat>
                  <v-card-text class="text-right">
                    <div class="mb-2 grey--text">engagement</div>
                    <span v-if="snapshot && snapshot.scores && snapshot.scores.engagement_score" class="black--text text-bold font-xxl">
                      {{ snapshot.scores.engagement_score }}%
                    </span>
                    <span v-else>n/a</span>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card flat>
                  <v-card-text class="text-center">
                    <div class="mb-2 grey--text">activity</div>
                    <span v-if="snapshot && snapshot.pts_vs_baseline" class="black--text text-bold font-xxl">
                      <span>{{ snapshot.pts_vs_baseline > 1 ? '+' : '' }}</span>
                      <span>{{ (snapshot.pts_vs_baseline - 1) * 100 | int }}%</span>                  
                    </span>
                    <span v-else>n/a</span>                
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card flat>
                  <v-card-text class="text-center">
                    <div class="mb-2 grey--text">improvers</div>
                    <span v-if="snapshot && snapshot.scores && snapshot.scores.move_score" class="black--text text-bold font-xxl">
                      {{ snapshot.scores.move_score }}%
                    </span>
                    <span v-else>n/a</span>                
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>   
          <div v-if="!insights" class="mx-4">
            <v-progress-circular indeterminate size="50" color="grey" />
          </div>
          <div v-if="insights && !snapshot" class="mx-4">
            <p class="font-xs font-italic">Insights are not yet available for this event. Please check back in a few days.</p>
          </div>
        </v-col>
        <v-col cols="12">
          <v-card-subtitle class="py-0">Most Popular <span class="not-bold">Sports</span></v-card-subtitle>
          <div v-if="snapshot && snapshot.podiums" class="mx-4">
            <div v-for="(item, idx) in snapshot.podiums" :key="idx">
              <div :class="{ 'grey--text': !item.stats.supported, 'd-flex': true }">
                <div style="flex-basis: 30px">
                  <v-icon :color="item.stats.supported ? 'black' : 'grey'" small class="me-2">{{ $helpers.getActivityIcon(item.stats.type) }}</v-icon>
                </div>
                <div :class="{ 'inline-bar': true, 'active': item.stats.supported }" :style="`flex: ${item.stats.time/snapshot.podiums[0].stats.time}; }`">
                </div>
                <span class="bar-chart-label" style="font-size: 90%;">{{item.stats.time | duration(true)}}</span>
              </div>
            </div>
            <div v-if="snapshot.podiums.find(x => !x.stats.supported)" class="font-xs text-center">
              <v-divider class="my-2" />
              <span>▮ supported in event</span> <span class="ms-4 grey--text">▮ not supported in event</span>
            </div>
          </div>
          <div v-if="!insights" class="mx-4">
            <v-progress-circular indeterminate size="50" color="grey" />
          </div>
          <div v-if="insights && !snapshot" class="mx-4">
            <p class="font-xs font-italic">Insights are not yet available for this event. Please check back in a few days.</p>
          </div>
        </v-col>
        <v-col cols="12">
          <v-card-subtitle class="py-0"><span class="not-bold">Participants per</span> League</v-card-subtitle>
          <v-container v-if="snapshot" class="px-4 container--min-height">
            <v-row v-if="snapshot.assessment && snapshot.assessment.tiers">
              <v-col v-for="(item, idx) in snapshot.assessment.tiers" :key="idx" cols="12" sm="4" md="3">
                <div class="text-muted">{{ item.tier | league(true) }} </div>
                <v-chip small :color="`league-${item.tier}`" style="aspect-ratio:1;" class="me-2">&nbsp;</v-chip>
                <span class="">{{ item.count}}<span class="grey--text">x</span></span>
              </v-col>
            </v-row>   
            <div v-else>
              <p class="text-muted">League information not (yet) available. Please check back tomorrow.</p>   
            </div>   
          </v-container>   
          <div v-if="!insights" class="mx-4">
            <v-progress-circular indeterminate size="50" color="grey" />
          </div>
          <div v-if="insights && !snapshot" class="mx-4">
            <p class="font-xs font-italic">Insights are not yet available for this event. Please check back in a few days.</p>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-hover>
</template>

<script>
import { DateTime } from 'luxon'
import siteData from '@/data/site.json'
import EventUtil from "@/util/eventUtil";
import OrgUtil from "@/util/orgUtil";
import eventManagerService from "@/services/eventManagerService";
import orgManagerService from "@/services/orgManagerService";

export default {
  name: "InsightsSummary",
  components: {
  },
  props: {
    //event: Object,
    //org: Object,
  },
  data() {
    return {
      siteData: siteData,
      insights: null,
      snapshot: null,
      event: null,
      org: null,
    };
  },
  async mounted() {
  },
  methods: {

    async loadForEvent(event) {
      this.event = event;
      this.insights = (await eventManagerService.getInsights(this.event.id, /* date: */ null, /* currentOnly: */true)).data;
      this.snapshot = this.insights && this.insights.latest;
      console.log('/// current insights', this.snapshot);
    },

    async loadForOrg(org) {
      this.org = org;
      this.insights = (await orgManagerService.getInsights(this.org.id, /* date: */ null, /* currentOnly: */true)).data;
      this.snapshot = this.insights && this.insights.latest;
      console.log('/// current insights', this.snapshot);
    },

  },

  computed: {
    eventMode() { return this.event != null; },

    eventUtil() {
      return new EventUtil(this, this.event);
    },

    orgUtil() {
      return new OrgUtil(this, this.org);
    },

  },

};
</script>
<style lang="scss">
.v-card__subtitle {
  padding-bottom: 0;
}

.row--separated {
  .col + .col {
    border-left: solid 1px #ccc;
  }
}
.container--min-height {
  padding-top: 0;
  padding-bottom: 0;
  .row > div { 
    padding-top: 0;
    padding-bottom: 0;
   }
}

.chart-floating-label {
  position: absolute;
  right: 0;
  bottom: 0;
}
.inline-bar {
  border: solid 1px #aaa;
  background-color: #ccc;
  margin: 8px 4px;
}
.inline-bar.active {
  border-color: black;
  background-color: #333;
}
.bar-chart-label {
  padding-top: 2px;
}
.not-bold { font-weight: normal;}
</style>

